<juridico-header></juridico-header>
  <main id="main">
    <div class="d-flex align-items-center justify-content-center contato-concluido mt-5 pt-5" style="min-height: 500px;">
        <div class="p-nav mt-5 pt-5 text-center">
            <h1 class="mt-5"><strong>Usuário não encontrado!</strong></h1>
            <p class="lead">
                Não foi possível efetuar o cancelamento da notificação por e-mail do cadastro como analista de novas vagas!
            </p>
            <p class="lead">
                Clique em <strong>Continuar</strong> para retornar a homepage!
            </p>
            <p class="lead">
                <small>Ou aguarde 5 segundos para ser redirecionado.</small>
            </p>
            <p class="text-center mt-3">
                <a href="/" [routerLink]="['/']" title="Continuar" class="">
                    <button class="button">Continuar</button>
                </a>
            </p>
        </div>
    </div>
  </main>
<juridico-footer></juridico-footer>